@if (isUserLoggedInPages) {
  <header class="header header-bg">
    <div class="header__left">
      <div class="header__left--logo">
        <div class="navbar-wrapper">
          <a id="minimizeSidebar" (click)="toggleSidebar()">
            <img src="assets/img/Icon-Menu.svg" alt="Menu">
          </a>
          @if (pageTitle) {
            <span class="navbar-brand">{{ pageTitle }}
              @if (pageTitleList.length > 0) {
                | {{ pageTitleList.join(' |')}}
              }
            </span>
          }
        </div>
      </div>
    </div>
    <div class="dropdown">
      <div class="header__profile">
        <ul>
          <li><img class="profileimg" [src]="imageURL"></li>
          <li>{{ userName }}</li>
          <li>
            <a class="dropdown-toggle" id="dropdownMenuButton" data-mdb-toggle="dropdown"
              aria-expanded="false"><img src="assets/img/down-arrow.svg"></a>
            </li>
          </ul>
        </div>
        <div class="header__profile--list dropdown-menu" aria-labelledby="dropdownMenuButton">
          <ul>
            <li>
              <a (click)="changePassword()"><img src="assets/img/change-pass.svg">Change Password</a>
            </li>
            <li>
              <a [routerLink]="['/documentation']"><img src="assets/img/doc-icon.svg">Documentation</a>
            </li>
            <li>
              <a [routerLink]="['/login/logout']"><img src="assets/img/logout.svg">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  }

  @if (!isUserLoggedInPages) {
    <header class="header" style="display: none;">
      <div class="header__left">
        <div class="header__left--logo">
          <a routerLink="/"><img [src]="'assets/img/logo.png'" height="42"></a>
        </div>
      </div>
    </header>
  }